import React from "react";

/**
 * @component EditIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <EditIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const EditIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="EditIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M3 5v14a2 2 0 002 2h14a2 2 0 002-2v-7h-2v7H5V5h7V3H5c-1.11 0-2 .89-2 2zm6.875 10.535L18 7.41 16.59 6l-8.125 8.125a.997.997 0 101.41 1.41zM19.17 6.24L21 4.41 19.59 3l-1.83 1.83 1.41 1.41z"
        fillRule="evenodd"
      />
    </svg>
  )
);
EditIcon.displayName = "EditIcon";
export default EditIcon;
